import { formatPrismicData } from '@monofront/business/utils';
import Bubbles from './Bubbles';
import { IPrismicImage, IPrismicRichText } from '@monofront/types';
import SpacerDoodle from '@monofront/design-system/visuals/Illustrations/SpacerDoodle';
import { RichText } from 'prismic-reactjs';

type IDualBubblesProps = {
  prismicContent: {
    primary: {
      title: IPrismicRichText;
    };
    items: {
      image: IPrismicImage;
      main_text: IPrismicRichText;
      sub_text: IPrismicRichText;
    }[];
  };
};

const DualBubbles: React.FC<IDualBubblesProps> = ({ prismicContent }) => {
  const content = formatPrismicData(prismicContent);
  const bubbles = content?.items
    ?.slice(0, 2)
    .map(({ image, mainText, subText }, index) => ({
      image,
      title: mainText,
      text: subText,
      position: index % 2 ? 'bottom-right' : 'top-left',
    }));

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-12 tw-pb-[63px] tw-pt-2">
      {content.primary?.title && (
        <div className="tw-mb-3 md:tw-mb-0 [&>*]:tw-font-title [&>*]:tw-text-3xl [&>*]:tw-font-bold">
          <RichText render={content.primary.title} />
        </div>
      )}
      <Bubbles
        // FIXME: fixed in !1994
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        bubbles={bubbles}
        spacer={<SpacerDoodle />}
      />
    </div>
  );
};

export default DualBubbles;
